/* HOLLOW — ambient star field.
   Monochrome motes drift upward slowly, like ash off a snuffed candle.
   Static single frame if the visitor prefers reduced motion. */
(function () {
  function init() {
    var canvas = document.getElementById('hollow-stars');
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var stars = [];
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var w, h;

    function resize() {
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w * DPR;
      canvas.height = h * DPR;
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
    }

    function seed() {
      var count = Math.max(40, Math.round((w * h) / 9000));
      stars = [];
      for (var i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.3 + 0.25,
          base: Math.random() * 0.45 + 0.12,
          speed: Math.random() * 0.12 + 0.02,
          tSpeed: Math.random() * 0.02 + 0.004,
          tPhase: Math.random() * Math.PI * 2,
          gold: Math.random() > 0.88
        });
      }
    }

    function frame(t) {
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        var alpha = reduceMotion ? s.base : s.base + Math.sin(t * s.tSpeed + s.tPhase) * 0.16;
        alpha = Math.max(alpha, 0.03);
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.gold
          ? 'rgba(168,146,95,' + alpha + ')'
          : 'rgba(229,222,209,' + alpha + ')';
        ctx.fill();
        if (!reduceMotion) {
          s.y -= s.speed;
          if (s.y < -4) {
            s.y = h + 4;
            s.x = Math.random() * w;
          }
        }
      }
      if (!reduceMotion) requestAnimationFrame(frame);
    }

    window.addEventListener('resize', function () {
      resize();
      seed();
    });

    resize();
    seed();
    requestAnimationFrame(frame);
    if (reduceMotion) frame(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
